module.exports = __webpack_public_path__ + "static/media/confirmacion__Festeja.d34f40bd.svg";